// extracted by mini-css-extract-plugin
export var body = "Layout-module--body--330b2";
export var closeText = "Layout-module--close-text--ee5d0";
export var gnb = "Layout-module--gnb--a2efd";
export var gnbWrap = "Layout-module--gnb-wrap--13b24";
export var gnb__item = "Layout-module--gnb__item--8d4ca";
export var gnb__link = "Layout-module--gnb__link--8f5af";
export var gnb__linkText = "Layout-module--gnb__link-text--3cd80";
export var gnb__list = "Layout-module--gnb__list--a0806";
export var head = "Layout-module--head--24c2b";
export var headBg = "Layout-module--head-bg--79dff";
export var head__gnbOpener = "Layout-module--head__gnb-opener--63477";
export var head__logo = "Layout-module--head__logo--40984";
export var head__logo__link = "Layout-module--head__logo__link--ffd89";
export var isDark = "Layout-module--is-dark--39fb2";
export var isGnbOpened = "Layout-module--is-gnb-opened--0b4dc";
export var isHome = "Layout-module--is-home--e8e9e";
export var isOpened = "Layout-module--is-opened--6687c";
export var isScroll = "Layout-module--is-scroll--e581d";
export var openText = "Layout-module--open-text--5d228";
export var wrap = "Layout-module--wrap--34ce4";